/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./sidebar-item.vue?vue&type=template&id=65a5d10a&scoped=true&"
import script from "./sidebar-item.vue?vue&type=script&lang=js&"
export * from "./sidebar-item.vue?vue&type=script&lang=js&"
import style0 from "./sidebar-item.vue?vue&type=style&index=0&id=65a5d10a&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a5d10a",
  null
  
)

export default component.exports